export default {"src":"/_next/static/media/icon.1574be08.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};